// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Products from './Products';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Products);
